import React, { ReactNode } from 'react';
import { Grid, Typography } from '@mui/material';
import { ErrorOutline, InfoOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from '../common/ui/ConfimationDialog';
import { mb } from '../common/theme/mbTokens';
import { PaymentProvider, PROVIDER_NAMES } from './ProviderCard';

type DisconnectProviderDialogProps = {
  provider: PaymentProvider | null;
  renewalsWaitingCount: number;
  onClose: (actionConfirmed: boolean) => void | Promise<void>;
};

const ImpactLine = ({ icon, text }: { icon: ReactNode; text: string }) => (
  <Grid container alignItems="flex-start" flexWrap="nowrap" gap={1}>
    {icon}
    <Typography>{text}</Typography>
  </Grid>
);

export const DisconnectProviderDialog = ({
  provider,
  renewalsWaitingCount,
  onClose,
}: DisconnectProviderDialogProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      isOpen={!!provider}
      onClose={onClose}
      fullScreenOnMobile
      title={t('payments.disconnectDialog.title', { provider: provider ? PROVIDER_NAMES[provider] : '' })}
      ctaText={t('payments.disconnect')}
      content={
        <Grid container flexDirection="column" gap={1.5}>
          <Typography>{t('payments.disconnectDialog.body')}</Typography>
          {provider === 'square' && (
            <>
              {renewalsWaitingCount > 0 && (
                <ImpactLine
                  icon={<ErrorOutline fontSize="small" color="error" />}
                  text={t('payments.disconnectDialog.renewals', { count: renewalsWaitingCount })}
                />
              )}
              <ImpactLine
                icon={<ErrorOutline fontSize="small" color="error" />}
                text={t('payments.disconnectDialog.cards')}
              />
              <ImpactLine
                icon={<InfoOutlined fontSize="small" sx={{ color: mb.muted }} />}
                text={t('payments.disconnectDialog.reconnect')}
              />
            </>
          )}
        </Grid>
      }
    />
  );
};
